module.exports = __webpack_public_path__ + "img/Step1.a4685306.png";